// https://www.kunkalabs.com/mixitup/docs/get-started/
import mixitup from 'mixitup';

$(document).ready(function() {
    var initialFilter = 'all';
    var hash = window.location.hash.replace(/^#/g, '');
    if (hash) {
        initialFilter = '.' + hash;
    }

    if ($('.mixit--filter').length) {
        var mixer = mixitup(".mixit--filter", {
            animation: {
                animateResizeTargets: true,
                duration: 550,
                nudge: true,
                reverseOut: false,
                effects: "fade scale(0.01) translateZ(-100px)"
            },
            selectors: {
                control: '.mixitup-control'
            },
            load: {
                filter: initialFilter
            }
        });
    }
});


jQuery(document).ready(function($) {
    var page = 2; // Start loading from page 2
    var loading = false;

    $('#load-more').on('click', function() {
        if (loading) return; // Prevent multiple clicks
        loading = true;
        var button = $(this);

        $.ajax({
            url: ajax_params.ajax_url,
            type: 'POST',
            data: {
                action: 'load_more',
                page: page,
                lang: ajax_params.lang || ''
            },
            beforeSend: function() {
                button.html(button.attr('data-loading'));
                button.removeClass('bg-primary hover:bg-primarydark border-2');
            },
            success: function(response) {      
                button.addClass('bg-primary hover:bg-primarydark border-2');
      
                if (response) {
                    $('#projekte').append(response);
                    button.text(button.attr('data-text'));
                    page++;
                    loading = false;
                } else {
                    button.text(button.attr('data-nomore'));
                    button.attr('disabled', true);
                }
            }
        });
    });
});
